import Axios from 'axios';
import CONFIG from '../../config';

const customAxios = Axios.create({
    baseURL: CONFIG.apiURL,
    headers: {authorization: `Bearer ${window.localStorage.jwt}`}
});

const reqHandler = req => {
    req.headers.authorization = `Bearer ${window.localStorage.jwt}`;
    return req;
};

const resHandler = res => {
    return res;
};

const errorHandler = error => {
     if (error.response?.status === 403) {
        window.location.href = '/access-denied';
    }
    return Promise.reject(error);
};

customAxios.interceptors.request.use(
    (request) => reqHandler(request),
    (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
    (response) => resHandler(response),
    (error) => errorHandler(error)
);

export default customAxios;